import { useQuery } from "@apollo/client";

import { ActiveProfileDoc } from "operations";

export const useAuthPrincipalQuery = () => {
  const result = useQuery(ActiveProfileDoc);
  const { data: principal } = result;
  return { principal, ...result };
};
